import * as React from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import MediaQuery from 'react-responsive';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import FiltersToggle from './FiltersToggle';
import Search from './Search';
import WatchListButton from './WatchListButton';
import ExplorerDownload from './ExplorerDownload';
import SortSelector from './SortSelector';
import { DataStore, FilterStore } from '../stores';
import ResizeDetector from './ResizeDetector';

const SearchHeader = styled<any, any>('header')`
    ${propStyles};
    top: 0;
`;

SearchHeader.defaultProps = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
    padding: 'lg',
};

interface HeaderProps {
    theme?: Theme;
    dataStore?: DataStore;
    filterStore?: FilterStore;
}

interface ThemeValue {
    [property: string]: string | number | Theme;
}

interface Theme {
    [property: string]: ThemeValue;
}

const Header: React.SFC<HeaderProps> = ({ theme, dataStore, filterStore }) => (
    <SearchHeader {...theme.SearchHeader}>
        <MediaQuery
            query={
                dataStore.config.filtersTop
                    ? `(max-width: ${theme.breakpoints.sm})`
                    : `(max-width: ${theme.breakpoints.md})`
            }
        >
            {matches =>
                matches && (
                    <FiltersToggle
                        onClick={filterStore.toggleFilters}
                        filtersActive={filterStore.filtersActive}
                        filtersCount={filterStore.filtersCount}
                    />
                )
            }
        </MediaQuery>
        {dataStore.config.identifierSearch &&
            dataStore.config.identifierSearch.properties && (
                <Search
                    total={dataStore.total}
                    search={dataStore.searchValues}
                    onChange={dataStore.search}
                    clearSearch={dataStore.clearSearch}
                />
            )}
        {dataStore.watchListEnabled && (
            <WatchListButton
                onClick={dataStore.toggleWatchList}
                active={dataStore.watchListActive}
                count={dataStore.watchListCount}
            />
        )}
        <ResizeDetector handleWidth={true} handleHeight={true}>
            <ExplorerDownload />
        </ResizeDetector>

        {dataStore.columnStore.sortableColumns.length > 0 && (
            <MediaQuery query={`(min-width: ${theme.breakpoints.sm})`}>
                {matches => !matches && <SortSelector order="2" />}
            </MediaQuery>
        )}
    </SearchHeader>
);

export default inject('dataStore', 'filterStore')(withTheme(observer(Header)));



// WEBPACK FOOTER //
// ./src/Components/Header.tsx